import { useT } from '_metronic/i18n/Metronici18n'
import { CustomTable, TableEmptyState } from 'app/components'
import { temVinculoMedicoAtivo, useAuth } from 'app/modules/auth'
import { SncrBloco } from '../../core/_models'
import { useQueryRequest } from '../core/QueryRequestProvider'
import { useQueryResponse } from '../core/QueryResponseProvider'
import { useSncrBlocosColumns } from './columns/_columns'

export const SncrBlocosTable = () => {
  const { t } = useT()
  const { currentUser } = useAuth()
  const { state } = useQueryRequest()
  const { isLoading, isError, refetch, response } = useQueryResponse()
  const columns = useSncrBlocosColumns()

  // Sem empresa a consulta nem roda (`enabled` do provider): o vazio explica o que falta. Quem chega
  // aqui sem vínculo médico (admin pela URL) não tem empresa para escolher — a tela não é para ele.
  const emptyState = state.params?.empresaId ? (
    <TableEmptyState
      title={t('sncr.lista.vazio_titulo')}
      description={t('sncr.lista.vazio_texto')}
    />
  ) : !temVinculoMedicoAtivo(currentUser?.vinculos) ? (
    <TableEmptyState
      title={t('sncr.lista.vazio_sem_vinculo_titulo')}
      description={t('sncr.lista.vazio_sem_vinculo_texto')}
    />
  ) : (
    <TableEmptyState
      title={t('sncr.lista.vazio_sem_empresa_titulo')}
      description={t('sncr.lista.vazio_sem_empresa_texto')}
    />
  )

  return (
    <CustomTable<SncrBloco>
      id='kt_table_sncr_blocos'
      ariaLabel={t('sncr.lista.tabela_aria')}
      itemLabel={{ singular: t('sncr.lista.item_singular'), plural: t('sncr.lista.item_plural') }}
      data={response?.data || []}
      columns={columns}
      isLoading={isLoading}
      isError={isError}
      onRetry={refetch}
      emptyState={emptyState}
      queryHooks={{ useQueryRequest, useQueryResponse }}
    />
  )
}
